let sadBoyRevealObserver;

const cleanupSadBoyMotion = (section) => {
  if (section && sadBoyRevealObserver) {
    section.querySelectorAll?.('[data-sb-reveal]').forEach((item) => sadBoyRevealObserver.unobserve(item));
    return;
  }
  sadBoyRevealObserver?.disconnect();
  sadBoyRevealObserver = undefined;
};

const initSadBoyMotion = () => {
  cleanupSadBoyMotion();

  if (document.documentElement.dataset.sbMotion === 'false') {
    document.documentElement.classList.remove('sb-motion-ready');
    document.querySelectorAll('[data-sb-reveal]').forEach((item) => item.classList.add('sb-is-visible'));
    return;
  }
  document.documentElement.classList.add('sb-motion-ready');

  const revealItems = [...document.querySelectorAll('[data-sb-reveal]')];
  if (!revealItems.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('sb-is-visible'));
    return;
  }

  sadBoyRevealObserver = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sb-is-visible');
        currentObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  revealItems.forEach((item, index) => {
    item.style.setProperty('--sb-reveal-delay', `${Math.min(index * 70, 280)}ms`);
    sadBoyRevealObserver.observe(item);
  });
};

window.initSadBoyMotion = initSadBoyMotion;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSadBoyMotion, { once: true });
} else {
  initSadBoyMotion();
}

document.addEventListener('shopify:section:load', initSadBoyMotion);
document.addEventListener('shopify:section:unload', (event) => cleanupSadBoyMotion(event.target));
